export default "__VITE_ASSET__CITsE9op__"